import { render, staticRenderFns } from "./RedimensionamentoHospitalarFiltro.vue?vue&type=template&id=c0f1ced4"
import script from "./RedimensionamentoHospitalarFiltro.vue?vue&type=script&lang=js"
export * from "./RedimensionamentoHospitalarFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports